import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import { LinearLayout, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { ErrorLabel } from '~/modules/coreUI/components/basic/Labels';
import Icon from '~/modules/coreUI/components/basic/Icon';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

const UnavailableProductLabel = ({ isRow, size }) => (
  <Column fullWidth>
    <Spacer size={[0.1, 0.1, 1.5, 1.5]} />
    <LinearLayout row={isRow} spaceBetween={0.5}>
      <Spacer size={1} />
      <Icon error className="el-icon el-icon-error" size={size} />
      <ErrorLabel semiBold nowrap size={size}>
        {i18next.t('ecommerceCoreUI:Product.UnavailableProductLabel')}
      </ErrorLabel>
    </LinearLayout>
    <Spacer size={3} />
  </Column>
);

UnavailableProductLabel.defaultProps = {
  isRow: true,
  size: ['sm'],
};

UnavailableProductLabel.propTypes = {
  isRow: PropTypes.bool,
  size: PropTypes.arrayOf(PropTypes.string),
};

export default UnavailableProductLabel;
